import httpClient from '../../api';

export default () => ({
  namespaced: true,

  state: () => ({
    communication: null,
    messages: [],
    pollingInProgress: false,
  }),

  getters: {
    communication: state => state.communication,
    messages: state => state.messages,
  },

  mutations: {
    setCommunication(state, payload) {
      state.communication = payload;
    },
    setMessages(state, payload) {
      state.messages = payload;
    },
    setPollingInProgress(state, value) {
      state.pollingInProgress = value;
    },
    reset(state) {
      state.communication = null;
      state.messages = [];
      state.pollingInProgress = false;
    },
  },

  actions: {
    async fetchCommunication({ commit }, code) {
      const res = await httpClient.get(`candidates/communication/${code}`);
      const comm = res.data.data ?? res.data;
      commit('setCommunication', comm);
      return comm;
    },

    async fetchMessages({ commit, state }, code) {
      if (state.pollingInProgress) return null;
      commit('setPollingInProgress', true);
      try {
        const res = await httpClient.get(`candidates/communication/${code}/messages`, {
          params: { page: 1, perPage: 50 },
        });
        const raw = res.data.data ?? res.data;
        const sorted = [...raw].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        commit('setMessages', sorted);
        return sorted;
      } finally {
        commit('setPollingInProgress', false);
      }
    },

    async sendMessage(context, { code, message }) {
      await httpClient.post(`candidates/communication/${code}`, { message });
    },

    async markAsRead(context, candidateId) {
      await httpClient.post(`candidates/communication/mark-as-read/${candidateId}`);
    },
  },
});
